



























































































































import { Vue } from "vue-property-decorator";
import TodoControl from "./TodoControl.vue";

interface AppState {
  newTodo: string;
  todos: Todo[];
  newCat: string;
  isClicked: boolean;
  categories: Category[];
}

interface Todo {
  title: string;
  isDone: boolean;
  isEditable: boolean;
  cate: string;
  createdAt: Date;
  completedAt?: Date;
}

interface Category {
  title: string;
  value: number;
  backgroundColor: string;
}

export default Vue.extend({
  components: {
    TodoControl
  },
  data() {
    const initialState: AppState = {
      newTodo: "",
      todos: [],
      newCat: "기타 ✔",
      isClicked: false,
      categories: this.$store.state.categories
    };
    return initialState;
  },
  created() {
    this.init();
  },
  computed: {
    todoLength(): number {
      return this.todos.length;
    },
    pendingTodo(): Todo[] {
      return this.$store.getters.pendingTodo;
    },
    doneTodo(): Todo[] {
      return this.$store.getters.doneTodo;
    }
  },
  methods: {
    init() {
      this.todos = this.$store.state.todos || [];
    },
    setTodos() {
      localStorage.setItem("userTodos", JSON.stringify(this.todos));
    },
    addTodo() {
      const todoItem = this.newTodo;
      if (!todoItem) return;

      const newTodoItem = {
        title: todoItem,
        isDone: false,
        isEditable: false,
        cate: this.newCat,
        createdAt: new Date()
      };
      this.$store.commit("addNewTodo", newTodoItem);
      this.newTodo = "";
    },
    checkDone(todo: Todo) {
      todo.isDone = !todo.isDone;
      if (todo.isDone === true) {
        todo.completedAt = new Date();
      }
      if (todo.isDone === false && todo.completedAt) {
        delete todo.completedAt;
      }

      this.setTodos();
    },
    handleEdit(todo: Todo) {
      todo.isEditable = !todo.isEditable;
    },
    handleChange(todo: Todo, event: any) {
      todo.title = event.target.value;
    },
    handleOption(todo: Todo, event: any) {
      todo.cate = event.target.value;
      this.setTodos();
    },
    modifyTodo(todo: Todo) {
      todo.isEditable = false;
      todo.isDone = false;
      this.setTodos();
    },
    handleDelete(index: number) {
      if (index >= this.todoLength) {
        throw new Error(
          `Index deletion at ${index} greater then ${this.todoLength}`
        );
      }
      const deleteItem = this.$store.getters.doneTodo[index];
      const realIndex = this.todos.indexOf(deleteItem);
      if (realIndex > -1) {
        this.$store.commit("removeOneItem", realIndex);
      }
    }
  }
});
